RivalIQ.apps.Share.module('views', function (views, App, Backbone, Marionette, $, _, cloneRedirectLocation) {

    'use strict';

    views.Signup = Marionette.View.extend({
        ui: {
            submit: '#btnSubmit',
            spinner: '.fa-spinner'
        },
        events: {
            'click @ui.submit': 'onSubmit',
            'keypress input': 'onKeypress'
        },

        initialize: function (options) {

            const me = this;
            const opts = me.options = options || {};

            _.extend(me, _.pick(opts, 'uuid', 'agid', 'scid'));

            // NOTE since we don't have a template but want to leverage ui
            // properties we need to create them manually
            _.each(me.ui, function (selector, name) {

                me.ui[name] = me.$(selector);
            });
        },
        onKeypress: function (e) {
            const me = this;
            if (e.which === 13) {
                e.preventDefault();
                me.onSubmit(e);
            }
        },
        validateForm: function (data) {

            const retVal = {};
            let returnError = false;
            const MIN_PASSWORD_LENGTH = 8;

            if (data.firstname.match(/^\s*$/)) {
                retVal.firstname = true;
                returnError = true;
            }
            if (data.lastname.match(/^\s*$/)) {
                retVal.lastname = true;
                returnError = true;
            }
            if (data.companyName.match(/^\s*$/)) {
                retVal.companyName = true;
                returnError = true;
            }
            if (data.companyTitle.match(/^\s*$/)) {
                retVal.companyTitle = true;
                returnError = true;
            }
            if (data.email.match(/^\s*$/)) {
                retVal.email = true;
                returnError = true;
            }
            if (data.password.match(/^\s*$/)) {
                retVal.passwordBlank = true;
                returnError = true;
            }
            if (data.password.length < MIN_PASSWORD_LENGTH) {
                retVal.passwordTooShort = true;
                returnError = true;
            }
            if (data.password !== data.passwordConfirm) {
                retVal.passwordDoesntMatch = true;
                returnError = true;
            }
            if (!data.companyType) {
                retVal.companyType = true;
                returnError = true;
            }

            if (!data.termsAndConditions) {
                retVal.termsAndConditions = true;
                returnError = true;
            }

            if (returnError) {
                return retVal;
            }
        },
        renderValidationError: function (error) {
            const me = this;

            const errorCodes = [
                {
                    errors: ['email'],
                    inputs: ['#inputEmail']
                },
                {
                    errors: ['firstname'],
                    inputs: ['#inputFirstname']
                },
                {
                    errors: ['lastname'],
                    inputs: ['#inputLastname']
                },
                {
                    errors: ['companyName'],
                    inputs: ['#inputCompanyName']
                },
                {
                    errors: ['companyTitle'],
                    inputs: ['#inputCompanyTitle']
                },
                {
                    errors: ['passwordBlank', 'passwordTooShort', 'passwordDoesntMatch'],
                    inputs: ['#inputPassword', '#inputPasswordConfirm']
                },
                {
                    errors: ['companyType'],
                    inputs: ['[name="companyType"]']
                },
                {
                    errors: ['termsAndConditions'],
                    inputs: ['input[name="termsAndConditions"]']
                }
            ];

            _.each(errorCodes, function (errorCode) {
                const hasError = _.some(errorCode.errors, function (errorType) {
                    return error[errorType];
                });

                _.each(errorCode.inputs, function (inputId) {
                    if (hasError) {
                        me.$(inputId).closest('.form-group').addClass('has-error');
                    } else {
                        me.$(inputId).closest('.form-group').removeClass('has-error');
                    }
                });
            });

            if (error.passwordTooShort) {
                me.$('.error-container').show(250);
                me.$('.x-error-msg').html('Password must be at least 8 characters long');

            } else if (error.passwordDoesntMatch) {
                me.$('.error-container').show(250);
                me.$('.x-error-msg').html(`Passwords don't match`);
            } else {
                me.$('.error-container').hide();
                me.$('.x-error-msg').html('');
            }
        },
        showPostSignupPage: function (email, pw, csrfToken) {
            const me = this;

            const PostSignupPage = RivalIQ.apps.Registration.views.PostSignupPage.extend({
                className: 'col-md-8 col-md-offset-2',
                // override onCompleteClicked to do our login dance
                onCompleteClicked: function () {
                    me.loginAndGo(email, pw, csrfToken);
                }
            });

            App.mainRegion.show(new PostSignupPage({
                isShare: true
            }));
        },
        loginAndGo: function (email, pw, csrfToken) {
            const me = this;
            const params = {
                username: email,
                password: pw,
                _csrf: csrfToken,
                originalDest: cloneRedirectLocation
            };

            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.V3SignedUp);
            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.V3ClonePageConversion);
            RivalIQ.execute('tracking:identify', email);

            setTimeout(function () {

                me.createAndPostDynamicForm(params);
            }, 500);
        },
        onSubmit: function (e) {

            const newAccount = new App.models.CreateAccount();
            const email = this.$('#inputEmail').val();
            const pw = this.$('#inputPassword').val();
            const csrfToken = this.$('#_csrf').val();
            const companyType = this.$('[name="companyType"]').val();
            const termsAndConditions = this.$('input[name="termsAndConditions"]').is(':checked');
            const gdprMessage = this.$('.x-gdpr-msg').html();

            const me = this;
            const newAccountData = {
                firstname: this.$('#inputFirstname').val(),
                lastname: this.$('#inputLastname').val(),
                companyName: this.$('#inputCompanyName').val(),
                companyTitle: this.$('#inputCompanyTitle').val(),
                email: email,
                password: pw,
                _csrf: csrfToken,
                passwordConfirm: this.$('#inputPasswordConfirm').val(),
                companyType: companyType,
                isAgency: companyType === 'agency',
                termsAndConditions: termsAndConditions,
                gdprMessage: gdprMessage,
                uuid: Marionette.getOption(me, 'uuid'),
                agid: Marionette.getOption(me, 'agid'),
                scid: Marionette.getOption(me, 'scid')
            };
            const validationError = this.validateForm(newAccountData);

            e.preventDefault();

            if (validationError) {
                this.renderValidationError(validationError);

            } else {
                delete newAccountData.passwordConfirm;

                me.ui.submit.attr('disabled', true);
                me.ui.spinner.removeClass('display-none');

                RivalIQ.utils.hubSpot.augmentHubSpotFormData(newAccount);

                newAccount.save(newAccountData, {
                    success: function () {

                        me.showPostSignupPage(email, pw, csrfToken);

                    },
                    error: function (model, error) {

                        if (error.responseText) {

                            // this is a rest error from the server
                            const err = JSON.parse(error.responseText).RESTerror;
                            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.V3SignupError);

                            if (err.name === 'EmailAlreadyExistsError') {
                                me.$('.error-container').show(250);
                                me.$('.x-error-msg').html('An account with that email already exists in our system.');
                            }
                            if (err.name === 'BadEmailAddressError') {
                                me.$('.error-container').show(250);
                                me.$('.x-error-msg').html('That email address is invalid.');
                            }
                            if (err.name === 'DisposableEmailAddressError') {
                                me.$('.error-container').show(250);
                                me.$('.x-error-msg').html('Please use your work email to create your account.');
                            }
                            if (err.name === 'TooManyCompaniesAddedInPeriodError') {
                                me.$('.error-container').show(250);
                                me.$('.x-error-msg').html('This landscape contains too many companies for new accounts.');
                            }
                        }

                        me.ui.submit.removeAttr('disabled');
                        me.ui.spinner.addClass('display-none');
                    }
                });
            }

        },
        createAndPostDynamicForm: function (params) {
            const form = document.createElement('form');
            form.setAttribute('method', 'POST');
            form.setAttribute('action', '/login');

            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const hiddenField = document.createElement('input');
                    hiddenField.setAttribute('type', 'hidden');
                    hiddenField.setAttribute('name', key);
                    hiddenField.setAttribute('value', params[key]);

                    form.appendChild(hiddenField);
                }
            }
            document.body.appendChild(form);
            form.submit();
        }
    });

}, window.cloneRedirectLocation);
